(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dc-results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dc-results-compare')) {
    customElements.define('dc-results-compare', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        this.range = this.querySelector('input[type="range"]');
        if (!this.range || this.events) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.range.addEventListener('input', () => this.update(this.range.value), options);
        this.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
          if (event.pointerType === 'mouse') {
            event.preventDefault();
            this.range.focus({ preventScroll: true });
          }
          this.setPointerCapture(event.pointerId);
          this.move(event);
        }, options);
        this.addEventListener('pointermove', (event) => {
          if (this.hasPointerCapture(event.pointerId)) this.move(event);
        }, options);
        const release = (event) => {
          if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
        };
        this.addEventListener('pointerup', release, options);
        this.addEventListener('pointercancel', release, options);
        this.update(this.range.value);
      }
      move(event) {
        const bounds = this.getBoundingClientRect();
        if (bounds.width) this.update((event.clientX - bounds.left) / bounds.width * 100);
      }
      update(value) {
        const position = Math.round(Math.max(0, Math.min(100, Number(value))));
        this.style.setProperty('--position', position + '%');
        this.range.value = position;
        this.range.setAttribute('aria-valuetext', position + '% before, ' + (100 - position) + '% after');
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.events) this.events.abort();
        this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
